import React from 'react';
import { Column } from "rbx";
import Layout from "../../layout";
import AppFindForm from '../../../components/app/find_form';


const AppFindScreen = () => {

  return (
    <Layout>
      <Column.Group centered>
        <Column size={4}>
          <AppFindForm />
        </Column>
      </Column.Group>
    </Layout>
  )

}

export default AppFindScreen;

